import http from './http'

export function getModifiers(params = {}) {
  return http.get('modifier', { params }).then((res) => res.data)
}

export function createModifier(data) {
  return http.post('modifier', data).then((res) => res.data)
}

export function updateModifier(id, data) {
  return http.put(`modifier/${id}`, data).then((res) => res.data)
}

export function deleteModifier(id) {
  return http.delete(`modifier/${id}`).then((res) => res.data)
}
